import { fetchJSON } from '@/lib/api';

export type EmployeeRow = {
  id: string;
  employee_name: string;
  employeeName?: string;
  name?: string;
  [key: string]: unknown;
};

export function normalizeEmployeeRow(raw: Record<string, unknown>): EmployeeRow {
  const rawId = raw._id ?? raw.id;
  const id =
    rawId != null && typeof rawId === 'object' && 'toString' in (rawId as object)
      ? (rawId as { toString: () => string }).toString()
      : String(rawId ?? '');

  const employee_name =
    (raw.employee_name as string) ||
    (raw.employeeName as string) ||
    (raw.name as string) ||
    (raw.full_name as string) ||
    'Unknown';

  return {
    ...raw,
    id,
    employee_name,
    employeeName: employee_name,
    name: employee_name,
  };
}

/** Load tenant-scoped employees for dropdowns (session cookie required). */
export async function fetchEmployees(): Promise<EmployeeRow[]> {
  const res = await fetchJSON('/api/employees');
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data?.ok) {
    throw new Error(data?.error || `Failed to fetch employees (${res.status})`);
  }
  return (data.rows || [])
    .map((row: Record<string, unknown>) => normalizeEmployeeRow(row))
    .filter((e) => e.id.length > 0);
}
